import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import { InfoButton, TooltipForElement } from '../Elements';

import classes from './TextField.module.scss';

const TextField = ({
  value = '',
  name,
  labelText,
  type = 'text',
  onChange,
  className,
  classNameForInput,
  classNameLabelText,
  borderRadius = false,
  boxShadow = false,
  placeholder,
  errorText,
  infoButton = false,
  required = false,
  TextTooltip,
  autoComplete = 'off'
}) => {
  const language = useUserState().user.language;

  return (
    <div className={cn(classes.textField, className)}>
      <label className={classes.label}>
        {labelText && (
          <p className={cn(classes.labelText, classNameLabelText)}>
            {labelText}
          </p>
        )}
        <div className={classes.inputWrap}>
          <input
            autoComplete={autoComplete}
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={
              placeholder ? placeholder : t('textField', 'ENTER_LINK', language)
            }
            required={required}
            className={cn(
              classes.textInput,
              classes.classTextArea,
              borderRadius && classes.textInput_borderRadius,
              boxShadow && classes.textInput_boxShadow,
              errorText && classes.textInput_error,
              infoButton && classes.textInput_infoButton,
              classNameForInput
            )}
          />

          {infoButton && (
            <>
              <TooltipForElement
                text={TextTooltip}
                mode="white"
                className={classes.info}
              >
                <InfoButton />
              </TooltipForElement>
            </>
          )}
        </div>
      </label>
      {errorText && <p className={classes.errorText}>{errorText}</p>}
    </div>
  );
};

TextField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  labelText: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  classNameForInput: PropTypes.string,
  classNameLabelText: PropTypes.string,
  borderRadius: PropTypes.bool,
  boxShadow: PropTypes.bool,
  placeholder: PropTypes.string,
  errorText: PropTypes.string,
  infoButton: PropTypes.bool,
  required: PropTypes.bool,
  TextTooltip: PropTypes.string,
  autoComplete: PropTypes.string
};

export default TextField;
